'use strict';

export function JpZip(){
  $('.edit_user').on('change', '.jp-zip', function(){
    let el = $(this).attr('id').slice(0, -3);
    let zip = $(this).val();
    $.ajax({
      type: "GET",
      url: `/zip/${zip}`
    }).done( (data) => {
      if(data != null){
        $(`#${el}state`).val(data.state);
        $(`#${el}city`).val(data.city);
        $(`#${el}town`).val(data.town);
        $(`#${el}state_kana`).val(data.state_kana);
        $(`#${el}city_kana`).val(data.city_kana);
        $(`#${el}town_kana`).val(data.town_kana);
      }
    });
  });

  $('.formParts').on('change', 'input', function() {
    const inputs = $(this).parents('.formParts').eq(1).find('input');
    for (let i = 0; i < inputs.length - 1; i++) {
      if ((inputs[i].name.endsWith('[zip]') && inputs[i + 1].name.endsWith('[address]')) ||
        (inputs[i].name.endsWith('[郵便番号]') && inputs[i + 1].name.endsWith('[住所]'))
      ) {
        if(this !== inputs[i])return;
        $.ajax({
          type: "GET",
          url: `/zip/${inputs[i].value}`
        }).done((data) => {
          if (data != null) {
            inputs[i + 1].value = data.state + data.city + data.town;
          }
        });
      }
    }
  });

}


// WEBPACK FOOTER //
// ./app/javascript/packs/jp_zip.js